document.addEventListener("change", (event) => {
  const selector = event.target.closest(".js-card-variant");
  if (!selector) return;

  const card = selector.closest(".js-product-card");
  const option = selector.matches('input[type="radio"]')
    ? selector
    : selector.selectedOptions[0];
  const price = card?.querySelector(".price--card-purchase");
  const formatMoney = window.themeCore?.utils?.formatMoney;
  const format = price?.hasAttribute("data-currency-code-enabled")
    ? window.themeCore?.objects?.shop?.money_with_currency_format
    : window.themeCore?.objects?.shop?.money_format;
  if (!card || !option || !price || !formatMoney || !format) return;

  const amount = Number(option.dataset.price);
  const compare_amount = Number(option.dataset.comparePrice);
  const formatted_price = formatMoney(amount, format);
  price.classList.toggle("price--on-sale", compare_amount > amount);
  price.querySelectorAll("[data-product-price]").forEach((element) => {
    element.textContent = formatted_price;
    element.dataset.amount = String(amount);
  });

  const oldPrice = price.querySelector("[data-price-old]");
  if (oldPrice) oldPrice.textContent = formatMoney(compare_amount, format);

  const button = price.querySelector(".js-product-card-quick-view-button");
  if (button) button.dataset.variant = option.value;

  const quantity = card.querySelector(".js-product-card-min-value");
  if (quantity) quantity.value = option.dataset.minQuantity || "1";

  updateCardImage(card, option);
});

function updateCardImage(card, option) {
  const src = option.dataset.imageSrc;
  if (!src) return;

  const wrapper = card.querySelector(".product-card__image-wrapper.is-active");
  const picture = wrapper?.querySelector(
    ".product-card__image-picture:not(.product-card__image-picture--hover)"
  );
  const image = picture?.querySelector("img.product-card__image");
  if (!image) return;

  wrapper.dataset.variant = option.value;
  const srcset = option.dataset.imageSrcset;
  picture.querySelectorAll("source").forEach((source) => {
    source.srcset = srcset;
    source.dataset.srcset = srcset;
  });
  image.srcset = srcset;
  image.src = src;
  image.dataset.srcset = srcset;
  image.dataset.src = src;
  image.alt = option.dataset.imageAlt || image.alt;
  picture.classList.remove("lazy");

  // A variant image has no matching hover image, so keep it visible on hover.
  if (wrapper.dataset.originalWithHover === undefined) {
    wrapper.dataset.originalWithHover = String(
      wrapper.classList.contains("product-card__image-wrapper--with-hover")
    );
  }
  wrapper.classList.toggle(
    "product-card__image-wrapper--with-hover",
    option.dataset.hasVariantImage !== "true" &&
      wrapper.dataset.originalWithHover === "true"
  );
}
